<template>
  <div>
    <div v-if="isVisible" class="wrapper">
      <div class="text">{{ targetGroup.name }}</div>
      <div class="suffix">グループを編集中</div>
    </div>
  </div>
</template>

<script>
import { getters } from '@/vuex/modules/pointGroupOperation/constants'
import RouteHelper from '@/mixins/RouteHelper'

export default {
  name: 'TargetGroupIndicator',
  mixins: [RouteHelper],
  computed: {
    targetGroup() {
      return this.$store.getters[getters.targetGroup]
    },
    isVisible() {
      return !!this.targetGroup.id
    },
  },
}
</script>

<style scoped>
.wrapper {
  display: flex;
}
.text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
}
.suffix {
  white-space: nowrap;
}
</style>
